import _assign from "object-assign";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var iconSize = {
  high: 12,
  medium: 14,
  low: 16,
  touch: 18
};

function createLightPalette(_ref) {
  var blue400 = _ref.blue400,
      blue500 = _ref.blue500,
      grey90 = _ref.grey90,
      grey900 = _ref.grey900,
      white = _ref.white;
  return {
    backgroundTheme: white,
    border: grey90,
    color: grey900,
    state: {
      checked: {
        background: blue500,
        border: blue400,
        tick: white
      },
      hover: {
        border: blue400
      }
    }
  };
}

function createDarkPalette(_ref2) {
  var grey100 = _ref2.grey100,
      grey800 = _ref2.grey800,
      blue300 = _ref2.blue300,
      blue400 = _ref2.blue400,
      white = _ref2.white;
  return {
    backgroundTheme: grey800,
    border: grey100,
    color: white,
    state: {
      checked: {
        background: blue400,
        border: blue400,
        tick: grey800
      },
      hover: {
        border: blue300
      }
    }
  };
}

var getPalette = function getPalette(name, palette) {
  return name === 'dark' ? createDarkPalette(palette) : createLightPalette(palette);
};

var densityToTypeSizePaletteIndex = {
  touch: 70,
  low: 60,
  medium: 50,
  high: 40
};
export var CheckboxBaseStyle = function CheckboxBaseStyle(_ref3) {
  var toolkitTheme = _ref3.toolkit;

  var getFocusable = toolkitTheme.focusable.getFocusable,
      _toolkitTheme$palette = toolkitTheme.palette,
      type = _toolkitTheme$palette.type,
      toolkitPalette = _objectWithoutProperties(_toolkitTheme$palette, ["type"]);

  var palette = getPalette(type, toolkitPalette);

  var createDensityStyle = function createDensityStyle(density) {
    var indeterminateThicken = density === 'high' ? {
      height: 3,
      y: 5
    } : {};
    return {
      '& $icon': {
        height: iconSize[density],
        width: iconSize[density]
      },
      '&$indeterminate': {
        '& $checked': indeterminateThicken
      },
      '&$focusVisible': {
        '&:before': _assign({
          height: iconSize[density],
          width: iconSize[density],
          content: '""',
          display: 'block',
          position: 'absolute',
          top: 0,
          left: 0,
          background: 'transparent'
        }, getFocusable())
      }
    };
  };

  return {
    root: {
      background: 'none',
      color: palette.color,
      justifyContent: 'space-between',
      marginTop: 0
    },
    disabled: _assign({}, palette.state.disabled, {
      opacity: 0.7
    }),
    checked: {
      fill: palette.state.checked.background,
      '& $icon': {
        fill: palette.state.checked.border
      }
    },
    indeterminate: {
      flexGrow: 0,
      stroke: palette.border
    },
    checkedTick: {
      fill: palette.state.checked.tick
    },
    icon: {
      height: 14,
      width: 14,
      flexGrow: 0,
      stroke: palette.border,
      overflow: 'visible',
      '& g:not($checked)': {
        fill: palette.backgroundTheme
      }
    },
    iconRoot: {
      alignSelf: 'flex-start',
      width: 'auto',
      background: 'none',
      minHeight: 'auto',
      height: 'auto',
      padding: '1px 0',
      '&:before': {
        content: '""',
        width: 'auto',
        height: 'auto',
        display: 'block',
        position: 'absolute',
        top: 3,
        left: 0
      },
      '&:hover': {
        background: 'none',
        color: palette.state.checked.tick,
        '& $icon': {
          stroke: palette.state.hover.border
        }
      },
      '&$checked': {
        strokeWidth: 0,
        '&:hover': {
          background: 'transparent',
          '& $icon': {
            stroke: palette.state.checked.border
          }
        }
      },
      '&$disabled': {
        cursor: 'not-allowed',
        pointerEvents: 'visible'
      }
    },
    focusVisible: {},
    highDensity: createDensityStyle('high'),
    mediumDensity: createDensityStyle('medium'),
    lowDensity: createDensityStyle('low'),
    touchDensity: createDensityStyle('touch')
  };
};
export var CheckboxStyle = function CheckboxStyle(_ref4) {
  var toolkitTheme = _ref4.toolkit;

  var getDisabled = toolkitTheme.disabled.getDisabled,
      _toolkitTheme$palette2 = toolkitTheme.palette,
      type = _toolkitTheme$palette2.type,
      toolkitPalette = _objectWithoutProperties(_toolkitTheme$palette2, ["type"]),
      spacing = toolkitTheme.spacing,
      typography = toolkitTheme.typography;

  var palette = getPalette(type, toolkitPalette);

  var createDensityStyle = function createDensityStyle(density) {
    var spacingMixin = spacing[density].spacing;
    var spacer = spacingMixin(0.75);
    var fontSize = typography.size[densityToTypeSizePaletteIndex[density]];

    var labelTypography = _assign({
      letterSpacing: 0,
      fontSize: fontSize,
      lineHeight: typography.lineHeight,
      minHeight: typography.getMinHeight(fontSize)
    }, typography.getFace());

    return {
      '& $label': _assign({}, labelTypography, {
        marginLeft: spacingMixin(0.75),
        marginRight: spacingMixin(3),
        position: 'relative'
      }),
      '& $labelRoot': {
        marginTop: spacer
      }
    };
  };

  return {
    root: {
      lineHeight: 1
    },
    disabled: {
      pointerEvents: 'visible'
    },
    labelRoot: {
      marginLeft: 0,
      marginRight: 0,
      alignItems: 'flex-start',
      verticalAlign: 'baseline'
    },
    label: {
      color: palette.color,
      flexGrow: 1,
      width: 'auto',
      height: 'auto',
      display: 'block',
      background: 'none',
      '&$disabled': _assign({
        color: palette.color
      }, getDisabled())
    },
    labelDisabled: {},
    focusVisible: {},
    highDensity: createDensityStyle('high'),
    mediumDensity: createDensityStyle('medium'),
    lowDensity: createDensityStyle('low'),
    touchDensity: createDensityStyle('touch')
  };
};
var fullWidthHeightAdjustment = {
  high: {
    height: -4,
    marginBottom: -2
  },
  medium: {
    height: -6,
    marginBottom: -2
  },
  low: {
    height: -10,
    marginTop: 2,
    marginBottom: -2
  },
  touch: {
    height: -13,
    marginTop: 2,
    marginBottom: 3
  }
};
export var CheckboxGroupStyle = function CheckboxGroupStyle(_ref5) {
  var toolkitTheme = _ref5.toolkit;

  var _toolkitTheme$palette3 = toolkitTheme.palette,
      type = _toolkitTheme$palette3.type,
      toolkitPalette = _objectWithoutProperties(_toolkitTheme$palette3, ["type"]),
      getSize = toolkitTheme.size.getSize,
      spacing = toolkitTheme.spacing;

  var palette = getPalette(type, toolkitPalette);

  var createDensityStyle = function createDensityStyle(density) {
    var spacingMixin = spacing[density].spacing;

    var _getSize = getSize({
      density: density
    }),
        formControlHeight = _getSize.height;

    var fullWidthTranslateY = density === 'medium' ? 1 : 0;
    var horizontalTranslateY = density === 'medium' ? 1 : 0;
    return {
      '& $legend$horizontal, $legend$vertical': {
        transition: 'none',
        transform: 'translate(0px, 7px)'
      },
      '& $horizontal': {
        marginRight: spacingMixin(3)
      },
      '&$formField': {
        paddingLeft: spacingMixin(1)
      },
      '&$formField$horizontalRoot:not($formFieldFullWidth)': {
        transform: "translate(0, ".concat(horizontalTranslateY, "px)")
      },
      '&$formFieldFullWidth $formGroupHorizontal': {
        transform: "translate(0, ".concat(fullWidthTranslateY, "px)"),
        height: formControlHeight + fullWidthHeightAdjustment[density].height
      },
      '&$formFieldFullWidth $formGroupVertical': {
        marginBottom: fullWidthHeightAdjustment[density].marginBottom,
        marginTop: fullWidthHeightAdjustment[density].marginTop
      }
    };
  };

  return {
    root: {
      background: 'none',
      color: palette.color,
      justifyContent: 'space-between',
      marginTop: 0
    },
    horizontalRoot: {
      display: 'block'
    },
    formControlRoot: {
      width: '100%'
    },
    formGroupHorizontal: {
      display: 'flex',
      flexDirection: 'row'
    },
    formGroupVertical: {
      flexDirection: 'column',
      lineHeight: 1
    },
    horizontal: {
      display: 'block'
    },
    vertical: {
      padding: 0
    },
    legend: {
      marginBottom: 12,
      '&$horizontal': {
        display: 'block',
        "float": 'left',
        marginLeft: 4
      }
    },
    formField: {},
    formFieldFilled: {},
    formFieldFullWidth: {},
    formFieldLabelLeft: {},
    highDensity: createDensityStyle('high'),
    mediumDensity: createDensityStyle('medium'),
    lowDensity: createDensityStyle('low'),
    touchDensity: createDensityStyle('touch')
  };
};